<template>
    <div>{{ title }}</div>
    <div
        v-if="possibleChanges.length > 0"
        class="possible-product-changes"
    >
        <span
            v-for="product in possibleChanges"
            :key="product.id"
        >
            <Link
                :href="$route('products.products.show', {product: product.id})"
            >
                {{ product.name }}
            </Link>
        </span>
    </div>
    <div v-else>
        {{ __('messages.not_set') }}
    </div>
</template>

<script setup>

defineProps({
    possibleChanges: {
        type: Object,
        default: () => ({}),
    },
    title: {
        type: String,
        default: () => { return '' }
    }
})
</script>

<style lang="scss" scoped>
.possible-product-changes {
    line-height: 20px;

    & > span:not(:last-child):after {
        content: ' ● ';
    }
}
</style>
